import { Pipe, PipeTransform } from '@angular/core'
import { Client } from '@features/client/client.model'

@Pipe({
    name: 'clientIdentity',
    standalone: true
})
export class ClientIdentityPipe implements PipeTransform {

  transform(client?: Client | null): string {
    if (!client) return ''

    return client.personalInfo.name.firstName ?? client.username
  }

}
